import React, { Fragment, useState, useEffect } from 'react';
import SingleSelect from '../../common/Forms/SingleSelect';
import axios from 'axios';

const MailgunInfo = ({ domainFormOptions, initialDomain, initialTemplate, domainFormName = 'campaign[mailgun_domain]', templateFormName = 'campaign[template]'}) => {
  const [domain, setDomain] = useState(initialDomain);
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(initialTemplate);

  useEffect(() => {
    if (!domain) return;

    axios.get(`/admin/campaigns/templates?mailgun_domain=${domain.value}`)
      .then((res) => {
        setTemplates(res.data.templates.map(t => ({ label: t, value: t })))
      })
  }, [domain])

  const handleChange = (options) => {
    setDomain(options);
    setSelectedTemplate();
  };

  const handleTemplateChange = (options) => {
    setSelectedTemplate(options);
  }

  return (
    <Fragment>
      <label>
        Mailgun Domain
      </label>
      <input name={domainFormName}
             value={domain && domain.value}
             hidden />
      <SingleSelect
        handleChange={handleChange}
        options={domainFormOptions}
        selectedValue={domain}
        placeholderText='Select Mailgun Domain'
      />

      <br />
      <label>
        Mailgun Template
      </label>
      <input name={templateFormName}
             value={selectedTemplate && selectedTemplate.value}
             hidden />
      <SingleSelect
        skipDefault
        handleChange={handleTemplateChange}
        options={templates}
        selectedValue={selectedTemplate}
        placeholderText='Select Mailgun Template'
      />
    </Fragment>
  );
};

export default MailgunInfo;
